__turbopack_context__.v({
  "container": "styles-module___Q7iCG__container",
  "disableTopPadding": "styles-module___Q7iCG__disableTopPadding",
  "doubleImageContainer": "styles-module___Q7iCG__doubleImageContainer",
  "doubleImageItem": "styles-module___Q7iCG__doubleImageItem",
  "extraText": "styles-module___Q7iCG__extraText",
  "hideOnDesktop": "styles-module___Q7iCG__hideOnDesktop",
  "hideOnMobile": "styles-module___Q7iCG__hideOnMobile",
  "imageGrid": "styles-module___Q7iCG__imageGrid",
  "singleImageContainer": "styles-module___Q7iCG__singleImageContainer",
  "slide": "styles-module___Q7iCG__slide",
  "slideImage": "styles-module___Q7iCG__slideImage",
  "sliderContainer": "styles-module___Q7iCG__sliderContainer",
  "sliderNavigation": "styles-module___Q7iCG__sliderNavigation",
  "slidersContainer": "styles-module___Q7iCG__slidersContainer",
  "withDivider": "styles-module___Q7iCG__withDivider",
});
